import { useMemo } from 'react'
import styles from './CNDownloadPage.module.css'

function CNDownloadPage() {
  const IsPC = useMemo(() => {
    const userAgentInfo = navigator.userAgent
    const Agents = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod',
    ]
    let flag = true
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false
        break
      }
    }
    return flag
  }, [])

  return IsPC ? (
    <></>
  ) : (
    <div className={styles.root}>
      <div className={styles.content}>
        <img
          className={styles.img}
          src="https://wx-chargespot.oss-cn-shenzhen.aliyuncs.com/images/scan.png"
          alt=""
        />
        <span>请使用微信或支付宝扫码哦~</span>
      </div>
    </div>
  )
}

export default CNDownloadPage
